import Tokens from "@paprika/tokens";
export function getAvatarColors(text) {
  var COLORS = [{
    background: Tokens.color.chartColor01,
    font: Tokens.color.white
  }, {
    background: Tokens.color.chartColor02,
    font: Tokens.color.white
  }, {
    background: Tokens.color.chartColor03,
    font: Tokens.color.black
  }, {
    background: Tokens.color.chartColor04,
    font: Tokens.color.black
  }, {
    background: Tokens.color.chartColor05,
    font: Tokens.color.white
  }, {
    background: Tokens.color.chartColor06,
    font: Tokens.color.white
  }, {
    background: Tokens.color.chartColor07,
    font: Tokens.color.black
  }, {
    background: Tokens.color.chartColor08,
    font: Tokens.color.white
  }, {
    background: Tokens.color.chartColor09,
    font: Tokens.color.white
  }, {
    background: Tokens.color.chartColor10,
    font: Tokens.color.white
  }, {
    background: Tokens.color.chartColor11,
    font: Tokens.color.black
  }, {
    background: Tokens.color.chartColor12,
    font: Tokens.color.black
  }];

  var reducer = function reducer(accumulator, letter) {
    return accumulator + letter.charCodeAt(0);
  };

  var textAsciiSum = text.split("").reduce(reducer, 0);
  var index = textAsciiSum % COLORS.length;
  return {
    fontColor: COLORS[index].font,
    backgroundColor: COLORS[index].background
  };
}
export function getInitialsFromText(text) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var initials = text.split(" ").map(function (word) {
    return word.charAt(0);
  });
  return initials.join("").substr(0, length);
}
//# sourceMappingURL=helpers.js.map